import React from 'react';
import { ctaMicrocopy, solution } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
export function SolutionSection() {
  return <section aria-labelledby="solution-title" className="bg-teal py-12 md:py-20" data-id="element-181" data-mp="3o9tt42icso1k">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-182" data-mp="3jah53efqxaxe">
        <SectionHeading id="solution-title" tone="dark" eyebrow={solution.eyebrow} title={solution.title} sub={solution.text} data-id="element-183" data-mp="3j8w9dlhp3lxy" />

        <ol className="mt-10 grid gap-4 md:mt-14 md:grid-cols-3 md:gap-6" data-id="element-184" data-mp="3t8dea0p4hvsv">
          {solution.steps.map((step, i) => <li key={step.title} className="flex gap-4 rounded-xl bg-teal-dark p-5 md:flex-col md:gap-3 md:p-7" data-id="element-185" data-mp="auxdejuq40kg" data-mpi={i}>
              <span className="font-display text-[2.6rem] font-extrabold leading-none text-gold md:text-[3.2rem]" data-id="element-186" data-mp="5wcdymnapkx2">{i + 1}</span>
              <div data-id="element-187" data-mp="kt3itbfqnou2">
                <h3 className="font-display text-[18px] font-extrabold tracking-tight text-white md:text-[20px]" data-id="element-188" data-mp="kq7i5fciam1x">{step.title}</h3>
                <p className="mt-1.5 text-[16px] leading-relaxed text-white/80" data-id="element-189" data-mp="36b5iit6sl4d8">{step.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 flex max-w-[420px] justify-center md:mt-12" data-id="element-190" data-mp="3b9yv8je98rcc">
          <CtaButton microcopy={ctaMicrocopy} microTone="light" align="center" data-id="element-191" data-mp="3f9qz4ispe9bd" />
        </div>
      </div>
    </section>;
}